import { Component } from 'react';

export class Validation extends Component {
    static getFieldValidationState = function (key, errorResult) {
        if (getErrorForKey(key, errorResult) !== undefined) {
            return 'error';
        }
    }

    // Note: key lookup is not case sensitive
    static getFieldValidationText = function (key, errorResult) {
        var error = getErrorForKey(key, errorResult);
        if (error !== undefined) {
            return error.errorMessage;
        }
    }
}

function getErrorForKey(key, errorResult) {
    if (errorResult === undefined) {
        return;
    }
    var errorMessage = errorResult.errors.find(function (element) {
        return element.key.toLowerCase() === this.toLowerCase();
    }, key);
    return errorMessage;
}

export const UserRoles = Object.freeze({
    Administrator: "Administrator",
    StaffAnalyticsManager: "Staff Analytics Manager",
    StaffManagement: "Staff Management",
    StaffUser: "Staff User",
    SuperUser: "Super User",
    User: "User",
    PathwayStaffAnalyticsManager: "Pathway Staff Analytics Manager",
    AffiliateAnalyticsManager: "Affiliate Analytics Manager"

});

export const UserRelationshipTypes = Object.freeze({
    Hospital: 0,
    Affiliate: 1,
    GpoAreaManager: 2,
    GpoDistrictManager: 3,
    GpoEnterprise: 4,
    AffiliateAreaManager: 5,
    AffiliateDistrictManager: 6
});

export const FinancialDetailsFilter = Object.freeze({
    Active: "Active",
    Inactive: "Inactive",
    Undetermined: "Undetermined"
});

export const MappingStatus = Object.freeze({
    NeedsReview: 0,
    Confirmed: 1,
    Ignore: 2
});

export const RevenueCategoryMappingsFilter = Object.freeze({
    All: "All",
    Confirmed: "Confirmed",
    Ignored: "Ignored",
    NeedsReview: "Needs Validation",
    NotMapped: "Not Mapped"
});

export const CodeGroupMappingsFilter = Object.freeze({
    All: "All",
    Confirmed: "Confirmed",
    Unconfirmed: "Unconfirmed",
    NeedsReview: "Needs Validation",
    NotMapped: "Not Mapped"
});

//export const HospitalFeaturePermissions = Object.freeze({
//    Report: 0,
//    MarketingPlan: 1,
//    Budget: 2,
//    CallLog: 3,
//    Contacts: 4,
//    Financials: 5,
//    CodeGroupMappings: 6,
//    RevenueCategoryMappings: 7,
//    Details: 8,
//    Providers: 9,
//    Analyst: 10,
//    IntraCompanyCustomerMapping: 11,
//    IVet360Team: 12,
//    EOCScorecard: 13,
//	HRReports: 14
//});

export const HospitalFeaturePermissions = Object.freeze({
    Report: 0,
    MarketingPlan: 1,
    EOCScorecard: 2,
    HRReports: 3,
    Budget: 4,
    CallLog: 5,
    Contacts: 6,
    Financials: 7,
    CodeGroupMappings: 8,
    RevenueCategoryMappings: 9,
    Details: 10,
    Providers: 11,
    Analyst: 12,
    IntraCompanyCustomerMapping: 13,
    IVet360Team: 14
});

// Translates HospitalFeaturePermissions to UI nomenclature.
export const HospitalViewTabs = Object.freeze({
    Pulse: HospitalFeaturePermissions.Report,
    Marketing: HospitalFeaturePermissions.MarketingPlan,
    EOCScorecard: HospitalFeaturePermissions.EOCScorecard,
    HRReports: HospitalFeaturePermissions.HRReports,
    Budget: HospitalFeaturePermissions.Budget,
    CallLog: HospitalFeaturePermissions.CallLog,
    Contacts: HospitalFeaturePermissions.Contacts,
    CoaMapping: HospitalFeaturePermissions.Financials,
    CodeMapping: HospitalFeaturePermissions.CodeGroupMappings,
    RevenueMapping: HospitalFeaturePermissions.RevenueCategoryMappings,
    HospitalInfo: HospitalFeaturePermissions.Details,
    Providers: HospitalFeaturePermissions.Providers,
    Analyst: HospitalFeaturePermissions.Analyst,
    IntraCompanyCustomerMapping: HospitalFeaturePermissions.IntraCompanyCustomerMapping,
    IVet360Team: HospitalFeaturePermissions.IVet360Team
});

export const CallType = Object.freeze({
    Monthly: 0,
    OneOff: 1,
    Onboarding: 2
});

export const CallLogDepartment = Object.freeze({
    NotSelected: 0,
    Marketing: 1,
    Analytics: 2,
    HRT: 3,
    Other: 4,
    POA: 5
});

export const IsMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);



// WEBPACK FOOTER //
// ./src/helper.js